import { UrlConfig } from '@shared/configs/URL';

import { AthletesFactoryAPI } from './api';

export const AthletesClient = AthletesFactoryAPI({ apiUrl: UrlConfig.athletesApiUrl });
